export default __webpack_public_path__ + "static/media/logo-right.9ff5de42.svg";